// extracted by css-extract-rspack-plugin
export default {"wrapper":"H5Cf7AKmtT0DfhxI","image":"iG_5Fi0X5K8MfLaY","content":"wpaFaxhlIFoxkH1H"};